/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_For_Whom_DescriptionInputs */

const en_seo_for_whom_description = /** @type {(inputs: Seo_For_Whom_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal trainers, dieticians and physios in one place. Strength, shape, muscle, coming back from an injury or simply training regularly: find someone for your goal.`)
};

const pl_seo_for_whom_description = /** @type {(inputs: Seo_For_Whom_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenerzy personalni, dietetycy i fizjoterapeuci w jednym miejscu. Siła, sylwetka, masa, powrót po kontuzji albo regularny trening: znajdź kogoś pod swój cel.`)
};

/**
* | output |
* | --- |
* | "Personal trainers, dieticians and physios in one place. Strength, shape, muscle, coming back from an injury or simply training regularly: find someone for yo..." |
*
* @param {Seo_For_Whom_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_for_whom_description = /** @type {((inputs?: Seo_For_Whom_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_For_Whom_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_for_whom_description(inputs)
	return en_seo_for_whom_description(inputs)
});